const NO_SIDEBAR_ROUTES = ['/invitation', '/onboarding', '/signup', '/beta'];

export const isNoSidebarRoute = (pathname: string): boolean =>
  NO_SIDEBAR_ROUTES.some(route => pathname.startsWith(route));
